<template>
  <v-layout row wrap>
    <v-flex d-flex>
      <v-text-field
        label="Current Email address"
        v-model="value"
        :success-messages="sent ? ['We have sent an email to you to verify this change'] : []"
        :color="themes.candidate.light.input"
        :rules="rules" required
        :loading="loading"
        type="email"
        hint="Updating your email address will change your login credentials."
        readonly
      />
    </v-flex>
    <v-dialog v-model="updateEmail" max-width="500px" persistent>
      <v-btn slot="activator" :class="themes.candidate.light.primaryActionButton">Change</v-btn>
      <v-card>
        <v-card-title class="title" :class="themes.candidate.light.dialogTitle">
          Update email address
        </v-card-title>

        <v-alert color="warning" :value="true" class="black--text mt-0">
          A verification link will be emailed to your new email address shortly. Please click on the
          link contained within the email to verify that the address belongs to you.
        </v-alert>

        <v-form v-model="valid">
          <v-card-text>
            <v-text-field
              label="Email address"
              v-model="candidate.email"
              :color="themes.candidate.light.input"
              :loading="loading"
              :rules="rules"
              type="email"
            />
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn flat :color="themes.candidate.light.cancel" @click="updateEmail = false">
              Cancel
            </v-btn>
            <v-btn
              @click="submit"
              :disabled="!this.valid || this.value === this.candidate.email"
              :color="themes.candidate.light.primaryActionButton"
            >
              Send Verification Link
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
const emailPattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

// Vue Component
export default {
  props: { value: String },
  data() {
    return {
      // toggles
      loading: false,
      sent: false,
      updateEmail: false,
      // Model (object sent to API)
      candidate: {
        email: `${this.value}`,
      },
      // Validation
      valid: false,
      rules: [
        v => !!v || 'Email address is required.',
        v => emailPattern.test(v) || 'Please provide a valid email address.',
      ],
    }
  },
  methods: {
    submit() {
      if (this.valid && this.value !== this.candidate.email) {
        this.loading = true
        this.$store.dispatch('candidate/candidate/update', this.candidate).then(
          response => {
            this.loading = false
            this.sent = true
            this.email = this.value
            this.updateEmail = false
            this.$store.dispatch('snackbarSuccess', 'Updated Successfully')
            this.$emit('done')
          },
          errors => {
            this.loading = false
            this.email = this.value
            this.$store.dispatch('snackbarError', 'Update Failed')
          }
        )
      }
    },

    confirm() {
      this.loading = true
      Vue.$http.get('candidate/candidate/send_email_confirmation').then(() => {
        this.loading = false
        this.sent = true
        this.$emit('done')
      })
    },
  },
}
</script>
